import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AuthUser } from '@classes/auth/auth-user';
import { NavLink } from '@classes/nav-link';
import { NavLinks } from '@classes/navlinks/navlinks';
import { environment } from '@environments/environment';
import { AppConfigService } from '@services/app-config/app-config.service';
import { AuthService } from '@services/auth/auth.service';
import { DataService } from '@services/data/data.service';
import { NavService } from '@services/nav/nav.service';
import { SubscriptionBaseComponent } from 'app/shared/subscription-base/subscription-base';

@Component({
  selector: 'app-main-nav',
  templateUrl: './main-nav.component.html',
  styleUrls: ['./main-nav.component.scss']
})
export class MainNavComponent extends SubscriptionBaseComponent implements OnInit, OnChanges {
  @Input() isAuth: boolean;
  @Output() sidenavClose = new EventEmitter<void>();

  isAdmin = false;

  appVersion: string;
  user: AuthUser;
  isMaintenance: boolean;
  isLocalTranslations: boolean;
  navLinksApp: NavLinks[];
  navLinks: NavLink[];

  constructor(
    private configSrv: AppConfigService,
    private authSrv: AuthService,
    private navSrv: NavService,
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    private router: Router
  ) {
    super();
  }

  ngOnInit() {
    this.initSub();
    this.appVersion = environment.version;
    this.isMaintenance = this.configSrv.isMaintenance;
    this.isLocalTranslations = environment.localTranslations;
  }

  ngOnChanges(): void {
    if (this.isAuth) {
      this.user = this.authSrv.getUser();
      this.navLinks = this.navSrv.getNavLinks();
    } else {
      this.user = null;
      this.navLinks = null;
    }
  }

  onCloseSidenav(): void {
    this.sidenavClose.emit();
  }




  private initSub(): void {
    this.subscription
      .add(
        this.dataService.isAdmin.asObservable().subscribe(isAdmin => {
          this.isAdmin = isAdmin;
          this.cdr.detectChanges();

        })
      )
      .add(
        this.dataService.navLinks.subscribe({
          next: navlinks => this.navLinksApp = navlinks
        })
      );
  }
}
